/**
 * Structure copied from ../finance/receipt-columns.tsx — the same column shapes over
 * vendor/isomorphic/apps/isomorphic/src/app/shared/invoice/invoice-list/columns.tsx, applied to
 * Customers' newsletter subscribers. Read-only: nothing here changes a subscription, so there is
 * no ⋮ column; an address that belongs to a customer links to that customer.
 */
import { createColumnHelper } from "@tanstack/react-table";
import { Link } from "react-router-dom";
import { getStatusBadge } from "@steelyard/theme";
import { formatDate } from "../../lib/format";
import type { NewsletterSubscriber } from "../../lib/services/customers";
import { customerPath } from "../../lib/paths";

const columnHelper = createColumnHelper<NewsletterSubscriber>();

export const newsletterColumns = [
  columnHelper.accessor("email", {
    header: "Email",
    size: 280,
    cell: ({ row }) =>
      row.original.customerId ? (
        <Link to={customerPath(row.original.customerNumber || row.original.customerId)} className="text-primary hover:underline">
          {row.original.email}
        </Link>
      ) : (
        row.original.email
      ),
  }),
  columnHelper.accessor("status", {
    header: "Status",
    size: 160,
    cell: ({ row }) => getStatusBadge(row.original.status),
  }),
  columnHelper.accessor("source", {
    header: "Source",
    size: 140,
    cell: ({ row }) => <span className="capitalize">{row.original.source}</span>,
  }),
  columnHelper.accessor("subscribedAt", {
    header: "Subscribed",
    size: 150,
    cell: ({ row }) => formatDate(row.original.subscribedAt),
  }),
  columnHelper.accessor((subscriber) => subscriber.unsubscribedAt ?? "", {
    id: "unsubscribedAt",
    header: "Unsubscribed",
    size: 150,
    cell: ({ row }) => (row.original.unsubscribedAt ? formatDate(row.original.unsubscribedAt) : "—"),
  }),
];
